  
 export interface FAQItem {
  question: string;
  answer: string;
  category: string;
}
  export const faqData: FAQItem[] = [
    // Getting Started
    {
      category: 'Getting Started',
      question: 'How do I join Cadence?',
      answer: 'To join Cadence\'s beta program, please request a demo or contact admin@cadenceio.com. Eligibility is limited to record labels (independent or major), management companies, and distributors. Following our initial consultation to assess your pitching requirements, we will provide access to our beta pricing page. Account creation becomes available upon your first pitch credit purchase.'
    },
    {
      category: 'Getting Started',
      question: 'How do I create a pitch?',
      answer: 'After logging into your account, locate the green "Create Pitch" button on your main dashboard. Click this button to access the pitch creation form and begin building your submission.'
    },
    {
      category: 'Getting Started',
      question: 'How do I select streaming platforms for my pitch?',
      answer: 'Navigate to the "Platform Selection" section on the pitch creation page. Select your desired DSPs from the available options. Additionally, you may select "Email" to receive a formatted copy of your pitch that can be forwarded to industry contacts and partners as needed.'
    },
    {
      category: 'Getting Started',
      question: 'How do I choose specific subgenres?',
      answer: 'In the "General Information" section, use the "Main Genre" multi-select field to choose your primary genres. Based on your genre and DSP selections, relevant subgenres will populate in the "DSP-Specific Information" section. You may select up to three subgenres per DSP.'
    },
    {
      category: 'Getting Started',
      question: 'Where can I find platform-specific IDs (Spotify URI, Apple ID, ASIN)?',
      answer: '• Spotify URI: Navigate to the artist\'s Spotify profile, click the three dots beside "Follow," hold Ctrl/Cmd, select "Share," then copy the Spotify URI.\n• Apple ID: Access the artist\'s Apple Music profile, select "Copy Link," then locate the numerical string after the final forward slash in the URL.\n• ASIN: Visit the artist\'s Amazon Music profile, select "Copy Link," then find the numerical string following "artists/" in the URL.'
    },
    {
      category: 'Getting Started',
      question: 'How do I know a pitch has been submitted?',
      answer: 'Successful submissions are confirmed via email notification from sam@cadenceio.com. Additionally, you can monitor submission status in the "Pitch Status" column, where completed deliveries are marked as "Delivered."'
    },
    {
      category: 'Getting Started',
      question: 'How do I view analytics?',
      answer: 'Access the "Past Submissions" tab and scroll horizontally to locate the "View Analytics" button for each pitch. This will display playlist placement data and other performance metrics.'
    },
    {
      category: 'Getting Started',
      question: 'What\'s the difference between the dashboard and past submissions?',
      answer: 'The dashboard displays upcoming releases with future release dates. Once a release date passes, the pitch automatically transfers to the "Past Submissions" tab for historical tracking and analytics review.'
    },

    // Account & Access Management
    {
      category: 'Account & Access Management',
      question: 'Can multiple team members share one Cadence account?',
      answer: 'Yes, account sharing among team members is supported. We are developing enhanced team collaboration features that will allow all members to view pitches created by their colleagues, ensuring comprehensive information sharing across your organization.'
    },
    {
      category: 'Account & Access Management',
      question: 'How do I add or remove team members from my account?',
      answer: 'Currently, team member management requires contacting admin@cadenceio.com. A self-service team management feature allowing primary account holders to independently add members is in development.'
    },
    {
      category: 'Account & Access Management',
      question: 'How do I revoke access for former employees?',
      answer: 'Please contact admin@cadenceio.com immediately to request user account deactivation. Our support team will promptly remove access for departed employees.'
    },
    {
      category: 'Account & Access Management',
      question: 'How do I update my DSP login credentials in Cadence?',
      answer: 'Navigate to Settings and select the "DSP" tab. Here you can add new credentials or use the pencil icon next to each platform to edit existing login information.'
    },

    // Pricing & Credits
    {
      category: 'Pricing & Credits',
      question: 'How does the credit system work?',
      answer: 'Our credit system operates on a 1:1 basis—one credit equals one pitch submission. This credit-based system is temporary during our beta phase. Upon full platform launch, we will transition to a subscription-based model.'
    },
    {
      category: 'Pricing & Credits',
      question: 'What happens if I submit more pitches than I have credits for?',
      answer: 'Pitch submission requires sufficient credit balance. If you lack adequate credits, the system will prevent submission. Additional credits can be purchased directly through the Settings tab to continue your submissions.'
    },
    {
      category: 'Pricing & Credits',
      question: 'Do my credits expire?',
      answer: 'Yes, unused credits expire after six months from the date of purchase.'
    },
    {
      category: 'Pricing & Credits',
      question: 'Can I get a refund for unused credits?',
      answer: 'Refund requests must be submitted within 30 days of credit expiration. Please contact admin@cadenceio.com to discuss available options based on your specific circumstances.'
    },
    {
      category: 'Pricing & Credits',
      question: 'How do I purchase additional pitch credits?',
      answer: 'Credits can be purchased at cadenceio.com/beta-pricing or through your account Settings under the "Pitch Pack" tab. Additional credits may be purchased at any time, regardless of your current balance.'
    },

    // Technical & Integration
    {
      category: 'Technical & Integration',
      question: 'Which DSPs does Cadence currently integrate with?',
      answer: 'We currently deliver pitches to SoundCloud, Amazon Music, Spotify, TIDAL, Deezer, Audiomack, and Apple Music. Official API integrations with SoundCloud, Amazon Music, and Spotify are in development to enhance delivery efficiency and reliability.'
    },
    {
      category: 'Technical & Integration',
      question: 'What features are included in the beta vs. full version?',
      answer: 'Our beta phase includes continuous feature development, including enhanced analytics, roster management tools, and AI-powered utilities for description optimization and genre matching. These features will be included in our subscription model upon full launch. Note that beta pricing may adjust as new features are introduced.'
    },
    {
      category: 'Technical & Integration',
      question: 'What should I do if I experience technical issues or bugs?',
      answer: 'For technical support, please email admin@cadenceio.com and complete our bug report form: https://docs.google.com/forms/d/e/1FAIpQLSdlvynLx8B2khc29j8Eq4obsEgjql3xIyWU7SkA-KeFhC29U4w/viewform'
    },
    {
      category: 'Technical & Integration',
      question: 'What happens if Cadence experiences downtime?',
      answer: 'We strive to provide advance notice of scheduled maintenance. For unexpected service interruptions, please contact admin@cadenceio.com for status updates and estimated resolution times.'
    },

    // Pitch Management
    {
      category: 'Pitch Management',
      question: 'Can I edit a pitch after it\'s been submitted?',
      answer: 'Yes, submitted pitches remain editable. Navigate to the pitch\'s "Review" page and click the pencil icon in the upper right corner to return to the editing interface. After making changes, click "Save" to update your submission.'
    },
    {
      category: 'Pitch Management',
      question: 'How long does it take for pitches to be delivered to DSPs?',
      answer: 'Pitches are typically delivered within 2-3 hours of submission, with guaranteed delivery within 24 hours of submission.'
    },
    {
      category: 'Pitch Management',
      question: 'What information is required vs. optional for each pitch?',
      answer: 'Required fields vary based on your selected DSPs. In the General Information section, all fields are mandatory except Featured Artist and Alternative Title. Additional platform-specific requirements may appear based on your DSP selections.'
    },
    {
      category: 'Pitch Management',
      question: 'Can I save a pitch as a draft and submit it later?',
      answer: 'Draft functionality is currently in development and will be available in the near future.'
    },
    {
      category: 'Pitch Management',
      question: 'How do I delete or cancel a pitch?',
      answer: 'To delete a pitch, navigate to the pitch\'s review page and select the delete option. Please note that pitches already delivered to DSPs cannot be recalled, though you may contact support for assistance with urgent modifications.'
    },

    // Results & Performance
    {
      category: 'Results & Performance',
      question: 'Does Cadence guarantee playlist placements?',
      answer: 'While beta clients report increased playlist placements since adopting Cadence, we do not guarantee specific placement outcomes. Our primary value proposition focuses on operational efficiency, enabling your team to dedicate more time to creative and strategic initiatives.'
    },
    {
      category: 'Results & Performance',
      question: 'How long should I wait to see results from my pitches?',
      answer: 'Analytics become available 24 hours after release date, when pitches automatically transfer to the "Past Submissions" tab for performance tracking.'
    },
    {
      category: 'Results & Performance',
      question: 'What does each status mean (draft, submitted, delivered)?',
      answer: '• Draft: Pitch is incomplete with saved progress but missing required information\n• Submitted: User has completed and submitted the form; Cadence is preparing for DSP distribution\n• Delivered: Pitch has been successfully transmitted to all selected DSPs\n• Provisional: A pitch submitted with one or more fields flagged for later update. Your status shows as "Submitted" or "Delivered" — you can correct provisional fields by reopening the pitch and resubmitting at any time.'
    },

    // Data & Security
    {
      category: 'Data & Security',
      question: 'How does Cadence protect my login credentials?',
      answer: 'We implement enterprise-grade security including JWT authentication, encrypted data transmission, and secure AWS hosting. All credentials are AES-encrypted with restricted access controls to ensure maximum protection.'
    },
    {
      category: 'Data & Security',
      question: 'Who can see my pitch data?',
      answer: 'Pitch data access is limited to your organization\'s team members and authorized Cadence administrators. No external parties have access to your confidential submission information.'
    },
    {
      category: 'Data & Security',
      question: 'How long does Cadence store my information?',
      answer: 'Account credentials are maintained for the duration of your active account. Pitch data is retained to improve our service and provide historical analytics unless you specifically request deletion.'
    },
    {
      category: 'Data & Security',
      question: 'Can I request deletion of my data?',
      answer: 'Yes, data deletion requests are accommodated upon request. We recommend submitting deletion requests within 30 days of account termination for prompt processing.'
    },

    // Support & Troubleshooting
    {
      category: 'Support & Troubleshooting',
      question: 'What are Cadence\'s customer support hours?',
      answer: 'Customer support is available Monday through Friday, 8:00 AM to 6:00 PM Pacific Time, with a target response within two hours during business hours. Inquiries submitted outside business hours will experience longer response times.'
    },
    {
      category: 'Support & Troubleshooting',
      question: 'How do I report a bug or technical issue?',
      answer: 'Technical issues can be reported via email to admin@cadenceio.com or through our dedicated form: https://docs.google.com/forms/d/e/1FAIpQLSdlvynLx8B2khc29j8Eq4obsEgjql3xIyWU7SkA-KeFhC29U4w/viewform'
    },
    {
      category: 'Support & Troubleshooting',
      question: 'How do I request a new DSP integration?',
      answer: 'Integration requests can be submitted to sam@cadenceio.com or through our feedback form: https://docs.google.com/forms/d/e/1FAIpQLSdlvynLx8B2khc29j8Eq4obsEgjql3xIyWU7SkA-KeFhC29U4w/viewform'
    },
    {
      category: 'Support & Troubleshooting',
      question: 'What happens when the beta program ends?',
      answer: 'Beta program participants will receive a discount on their first year of subscription service. Your account, data, and functionality will remain unchanged, with the transition from credit-based to subscription-based billing being the primary change.'
    }
  ];